<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="22" height="14" viewBox="0 0 22 14">
    <path
      :fill="color"
      fill-rule="nonzero"
      d="M.702 13.771a.587.587 0 0 0 .93 0l9.378-11.79 9.378 11.79a.587.587 0 0 0 .93 0c.243-.305.243-.864 0-1.168L11.455.254C11.333.102 11.172 0 11.01 0c-.162 0-.323.102-.445.254l-9.863 12.4c-.121.203-.202.355-.202.558 0 .204.08.407.202.56z"
    />
  </svg>
</template>

<script>
export default {
  props: {
    size: {
      type: Number,
      default: 24,
    },
    color: {
      type: String,
      default: 'currentColor',
    },
  },
};
</script>
